import React from 'react'
import styled from 'styled-components'

import { pluralize, TimeAgo } from '@sketch/components'

import {
  ImageWrapper,
  GridWrapper,
  Name,
  DropdownButtonWrapper,
} from '../DocumentItem/DocumentItem.styles'
import {
  StyledSubtitleTextWrapper,
  StyledFolderIcon,
} from './ProjectTrashItem.styles'
import {
  ProjectTrashItemProps,
  getButtonProps,
  renderDropdown,
  renderPreview,
} from './utils'
import { handleDeletedAtTimeFormat } from '../DocumentItem'
// This is the grid item for the project in trash. It shares a bunch of
// functionalities with the list item and those functions belongs to the
// root ProjectTrashItem component
export const ProjectTrashItemGridView = styled(
  function ProjectTrashItemGridView(props: ProjectTrashItemProps) {
    const {
      className,
      name,
      documentsNumber = 0,
      deletedAt,
      renderDropdownItems,
      onClick,
    } = props

    const previewImage = renderPreview(props, 'grid')
    const a11yProps = onClick ? getButtonProps(onClick) : {}

    return (
      <GridWrapper className={className} title={name} {...a11yProps}>
        <ImageWrapper>{previewImage}</ImageWrapper>
        <Name>
          <StyledFolderIcon aria-label="Folder Icon" />
          {name}
        </Name>
        <StyledSubtitleTextWrapper>
          <b className="shrink">
            {`${documentsNumber} ${pluralize(
              'Document',
              'Documents',
              documentsNumber
            )}`}
          </b>

          <div className="keep-size">
            <TimeAgo date={deletedAt} formatter={handleDeletedAtTimeFormat} />
          </div>
        </StyledSubtitleTextWrapper>

        {renderDropdownItems && (
          <DropdownButtonWrapper>
            {renderDropdown(renderDropdownItems())}
          </DropdownButtonWrapper>
        )}
      </GridWrapper>
    )
  }
)``
